import { Component } from '@angular/core';

@Component({
  selector: 'store-search-bar-stencil',
  template: `
    <div class="search-bar-stencil-container">
      <div class="search-bar-stencil-line stencil-shimmer">
        <div class="search-bar-stencil-icon"></div>
      </div>
    </div>
  `,
  styles: [
    `
      .search-bar-stencil-container {
        height: 52px;
        display: flex;
        align-content: center;
        background-color: white;
        border-radius: 2px;
      }
      .search-bar-stencil-line {
        height: 30px;
        width: 350px;
        margin: auto 10px;
        display: flex;
        justify-content: flex-end;
      }
      .search-bar-stencil-icon {
        background-color: white;
        width: 20px;
        height: 20px;
        margin: auto 5px;
      }
    `,
  ],
  standalone: false,
})
export class SearchBarStencilComponent {}
